import { useQuery } from '@tanstack/react-query';
import { getUser } from '../api/userService';

/**
 * Hook para obtener un usuario por ID
 * @param {string|number} id
 */
export function useUserQuery(id) {
  return useQuery({
    queryKey: ['user', id],
    queryFn: async () => {
      const response = await getUser(id);
      return response.data;
    },
    enabled: !!id,
  });
} 